var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFxFormula(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 26,
    viewBox: "0 0 56 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 26,
    rx: 4,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2941 5.45965C28.3594 5.02473 28.6584 4.5625 29.084 4.5625C29.5148 4.5625 29.8652 4.91297 29.8652 5.34375H31.4277C31.4277 4.05141 30.3763 3 29.084 3C27.7704 3 26.915 4.12074 26.7487 5.22941L26.2462 8.625H23.8496V10.1875H26.0151L24.483 20.5419L24.4785 20.5785C24.437 20.9934 24.1116 21.4375 23.6934 21.4375C23.2626 21.4375 22.9121 21.087 22.9121 20.6562H21.3496C21.3496 21.9486 22.401 23 23.6934 23C25.0082 23 25.911 21.8617 26.0312 20.7541L27.5946 10.1875H29.9434V8.625H27.8257L28.2941 5.45965Z",
    fill: "#1A1D1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6523 12.6875H32.7759L31.7608 14.2143L31.084 12.6875H29.3749L30.7353 15.7566L28.5684 19.0156H30.4447L31.4858 17.4498L32.1799 19.0156H33.889L32.5113 15.9075L34.6523 12.6875Z",
    fill: "#1A1D1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFxFormula);
export default __webpack_public_path__ + "static/media/fx_Formula.21967dcd401d9a91e9cf929c9a945b43.svg";
export { ForwardRef as ReactComponent };